import { Injectable } from "@angular/core";
import { BBResponseContainer } from "../carrier/response-container";
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { timeout, tap } from 'rxjs/operators';
import { SRTubeValidationRequest } from './srtubevalidationrequest';


@Injectable()
export class CarrierGridService {

    constructor(private http: HttpClient) { }

    defaultTimeout = 600000;
    getCarrierByMaterialBarcode(srTubeValidationRequest: SRTubeValidationRequest): Observable<BBResponseContainer> {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'supreme-run/sample';
        return this.http.post<BBResponseContainer>(url, srTubeValidationRequest).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }
}


